import React, { FC, PropsWithChildren } from 'react';

import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';

import styles from './ProvisionItemList.module.scss';

const sectionId = 'ProvisionItemList';

interface ProvisionItemListProps {
  className?: string;
  title?: string;
}

const ProvisionItemList: FC<PropsWithChildren<ProvisionItemListProps>> = ({
  className,
  title,
  children,
  ...rest
}) => (
  <Flex {...rest} className={className} fullWidth fullHeight>
    <Copy variant="body" weight="bold" align="center">
      {title}
    </Copy>
    <Flex className={styles.list} gap="sm" fullWidth fullHeight>
      {children}
    </Flex>
  </Flex>
);

export type { ProvisionItemListProps };
export { ProvisionItemList, sectionId };
